import { ethers } from 'ethers';

export const isNativeCurrency = (address: string | undefined): boolean =>
  address === ethers.ZeroAddress;
